import { PromotionSettingTabs } from './PromotionSettingTabs'
import { withPromotionSettingTabs } from './withPromotionSettingTabs'

const ConnectedPromotionSettingTabs =
  withPromotionSettingTabs(PromotionSettingTabs)

export { ConnectedPromotionSettingTabs as PromotionSettingTabs }
